import styled from "styled-components";

const PreviewWrap = styled.div`
  display: flex;
`;

export default PreviewWrap;
